import styled from '@emotion/styled';

export const Page = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 8px 16px 32px;
  width: 100%;
  box-sizing: border-box;
`;
